import introJs from 'intro.js';
import { Tour } from 'intro.js/src/packages/tour';
import { TourOptions } from 'intro.js/src/packages/tour/option';

// const INTRODUCTION_TOUR_DONE = 'serviceboard-introduction-tour-done';
const INTROJS_ATTRIBUTE = 'data-intro-js';

declare global {
    interface Window {
        introJs: () => Tour;
    }
}

export const setupIntroductionTour = (introTourData: Partial<TourOptions>) => {
    setIntroductionTour(introTourData);
    displayIntroductionTourIfIsFirstVisit();
};

const displayIntroductionTourIfIsFirstVisit = () => {
    // SGMI-11011 Temporary disable introduction tour
    // const isFirstVisit = localStorage.getItem(INTRODUCTION_TOUR_DONE) === null;

    // if (isFirstVisit) {
    //     window.introJs().start();
    //     localStorage.setItem(INTRODUCTION_TOUR_DONE, new Date().toISOString());
    // }
};

export const displayIntroductionTour = (introTourData: Partial<TourOptions>) => {
    setIntroductionTour(introTourData);
    window.introJs().start();
};

const setIntroductionTour = (data: Partial<TourOptions>) => {
    const customIntroJs = introJs.tour();
    customIntroJs.setOptions(data);
    enableIntroductionTourButtonAction();
    window.introJs = () => customIntroJs;
};

const enableIntroductionTourButtonAction = () => {
    window.onclick = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const targetParent = target.parentElement as HTMLElement;

        const attribute =
            target?.getAttribute(INTROJS_ATTRIBUTE) ||
            targetParent?.getAttribute(INTROJS_ATTRIBUTE);
        if (attribute) {
            event.stopPropagation();
            executeIntroductionTourAction(attribute);
        }
    };
};

const executeIntroductionTourAction = (actionName: string) => {
    const actions: Record<string, () => void> = {
        'exit': () => window.introJs().exit(false),
        'previous': () => window.introJs().previousStep(),
        'next': () => window.introJs().nextStep(),
        'refresh': () => window.introJs().refresh(),
        'restart': () => window.introJs().goToStepNumber(1),
    };

    actions[actionName]?.();
};